// components/ProtectedRoute.jsx - USE THIS VERSION
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { InlineLoader } from './shared/PageLoader';
import { isMobileFriendly } from './Layout';

// While the session is checked: the app's night-sky background with a small centred spinner (it fades in after a moment,
// so a quick check shows nothing) — no sidebar or page skeleton that would then jump when the real layout appears.
function AuthLoading() {
  // a phone-ready page already gets the phone's width while the session is checked, so nothing resizes when it appears
  if (isMobileFriendly(window.location.pathname)) {
    const meta = document.querySelector('meta[name="viewport"]');
    if (meta) meta.setAttribute('content', 'width=device-width, initial-scale=1');
  }
  return (
    <div className="layout-root" style={{ alignItems: "center", justifyContent: "center" }}>
      <InlineLoader message="Cargando…" />
    </div>
  );
}

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  console.log('ProtectedRoute - User:', user?.username, 'Loading:', loading);

  if (loading) return <AuthLoading />;

  if (!user) {
    console.log('No user, redirecting to login');
    // a PDF was shared to the app while signed out: remember it, and open Pagos del Exterior right after the login
    if (window.location.pathname === '/return' && new URLSearchParams(window.location.search).get('share') === '1') {
      try { sessionStorage.setItem('pendingShare', '1'); } catch { /* private mode: the user just opens the panel */ }
    }
    return <Navigate to="/login" replace />;
  }

  let pendingShare = false;
  try { pendingShare = sessionStorage.getItem('pendingShare') === '1'; } catch { /* ignore */ }
  if (pendingShare && window.location.pathname !== '/return') {
    try { sessionStorage.removeItem('pendingShare'); } catch { /* ignore */ }
    return <Navigate to="/return?share=1" replace />;
  }

  console.log('User authenticated, rendering children');
  return children;
};

export default ProtectedRoute;